import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import user from './modules/user'
import favourites from './modules/favourites'
import dashboard from './modules/dashboard'
import templates from './modules/templates'
import template from './modules/template'
import charts from './modules/charts'
import chart from './modules/chart'
import documents from './modules/documents'
import document from './modules/document'
import tables from './modules/tables'
import table from './modules/table'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    favourites,
    dashboard,
    templates,
    template,
    charts,
    chart,
    documents,
    document,
    tables,
    table,
  },
})
